import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { childCategoriesOf } from "@/lib/categories";

// Links a hub page down to the categories nested under it in the navbar
// (Compliance -> Accounting & Finance, Registration -> Business Licences).
// Links rather than re-listing the child's service cards, so the same service
// isn't duplicated across two hub pages.
export const ChildCategories = ({ parentHref, parentLabel }) => {
  const children = childCategoriesOf(parentHref);
  if (!children.length) return null;

  return (
    <section className="relative bg-[rgb(238,242,250)] py-16 md:py-20" data-testid="child-categories">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <h2 className="text-2xl font-semibold tracking-tight text-navy-900 md:text-3xl">
            Also under {parentLabel}
          </h2>
        </Reveal>
        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2">
          {children.map(({ slug, label, tagline }) => (
            <Reveal key={slug} className="h-full">
              <Link
                to={`/${slug}`}
                data-testid={`child-category-${slug}`}
                className="group flex h-full flex-col rounded-3xl border border-slate-200 bg-white p-7 shadow-[0_8px_30px_rgba(0,0,0,0.04)] transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-2 hover:border-emerald2-300 hover:shadow-[0_20px_44px_rgba(15,30,60,0.12)]"
              >
                <h3 className="text-lg font-semibold text-navy-900 transition-colors group-hover:text-gold-600">{label}</h3>
                <p className="mt-2.5 flex-1 text-sm leading-relaxed text-slate-500">{tagline}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-navy-900 transition-colors group-hover:text-gold-600">
                  View {label}
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
